"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WError = exports.WERROR_SYMBOL = void 0;
const cerror_1 = __importDefault(require("./cerror"));
exports.WERROR_SYMBOL = Symbol.for('contextual-error/werror');
class WError extends cerror_1.default {
    name = 'WError';
    constructor(message, options) {
        super(message, Object.assign(options || {}, { skipCauseMessage: true }));
        Object.defineProperty(this, exports.WERROR_SYMBOL, { value: true });
        if (options?.name) {
            this.name = options.name;
        }
    }
    static isWError(obj) {
        return obj?.[exports.WERROR_SYMBOL] != null;
    }
}
exports.WError = WError;
exports.default = WError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2Vycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi93ZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsc0RBQTJDO0FBRTlCLFFBQUEsYUFBYSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMseUJBQXlCLENBQUMsQ0FBQztBQUVuRSxNQUFhLE1BQU8sU0FBUSxnQkFBTTtJQUNqQixJQUFJLEdBQVcsUUFBUSxDQUFDO0lBRXhDLFlBQVksT0FBZ0IsRUFBRSxPQUFpQjtRQUM5QyxLQUFLLENBQUMsT0FBTyxFQUFFLE1BQU0sQ0FBQyxNQUFNLENBQUMsT0FBTyxJQUFJLEVBQUUsRUFBRSxFQUFFLGdCQUFnQixFQUFFLElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQztRQUN6RSxNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSxxQkFBYSxFQUFFLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxDQUFDLENBQUM7UUFFNUQsSUFBSSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7WUFDbkIsSUFBSSxDQUFDLElBQUksR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDO1FBQzFCLENBQUM7SUFDRixDQUFDO0lBRU0sTUFBTSxDQUFDLFFBQVEsQ0FBQyxHQUFZO1FBQ2xDLE9BQVEsR0FBcUMsRUFBRSxDQUFDLHFCQUFhLENBQUMsSUFBSSxJQUFJLENBQUM7SUFDeEUsQ0FBQztDQUNEO0FBZkQsd0JBZUM7QUFFRCxrQkFBZSxNQUFNLENBQUMifQ==